<div class="grid-page-header" *ngIf="!title && settings.titleAndSubtitle">
  <div class="grid-page-header-left">
    <div>
      <h2 class="grid-page-title">{{ settings.titleAndSubtitle.title | translate}}</h2>
      <span class="grid-page-subtitle" *ngIf="settings.titleAndSubtitle.subtitle">
        {{ settings.titleAndSubtitle.subtitle | translate}}
      </span>
    </div>
    <app-grid-toggle *ngIf="settings.toggle || settings.toggleSamePage"
      (toggleGridEvent)="togglePages($event)" [toggleStatus]="isParentPage"
      [toggle]="settings.toggle" [toggleSamePage]="settings.toggleSamePage"></app-grid-toggle>
  </div>
  <div class="grid-page-header-right">

    <!-- ICL -->
    <a *ngIf="settings.icl" class="grid-export-btn"
      href="https://vivienda.buenosaires.gob.ar/calculadora_alquiler" target="_blank">
      <i class="fa-solid fa-calculator"></i> ICL
    </a>

    <!-- CSV simple -->
    <ng-container *ngIf="settings.csv">
      <button class="grid-export-btn" type="button" (click)="downloadCSV()" [disabled]="loadingCSV">
        <i class="fa-solid fa-file-csv"></i> CSV
      </button>
      <button class="grid-export-btn" type="button" (click)="downloadExcel()" [disabled]="loadingCSV">
        <i class="fa-solid fa-file-excel"></i> Excel
      </button>
    </ng-container>

    <!-- CSV con dropdown (returns / payments / contracts / fees) -->
    <ng-container *ngIf="settings.returnsCSV || settings.paymentsCSV || settings.contractsCSV || settings.feesCSV">
      <div class="dropdown" ngbDropdown>
        <button class="grid-export-btn" ngbDropdownToggle [disabled]="loadingCSV">
          <i class="fa-solid fa-file-csv"></i> CSV <i class="fa-solid fa-chevron-down ms-1" style="font-size:0.6rem"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
          <button class="dropdown-item"
            (click)="settings.returnsCSV ? downloadReturnsCSV('view') : settings.paymentsCSV ? downloadPaymentsCSV('view') : settings.contractsCSV ? downloadContractsCSV('view') : downloadFeesCSV('view')"
            [disabled]="loadingCSV">
            <fa-icon [icon]="['fas', 'eye']" class="me-2"></fa-icon>Vista
          </button>
          <button class="dropdown-item"
            (click)="settings.returnsCSV ? downloadReturnsCSV('all') : settings.paymentsCSV ? downloadPaymentsCSV('all') : settings.contractsCSV ? downloadContractsCSV('all') : downloadFeesCSV('all')"
            [disabled]="loadingCSV">
            <fa-icon [icon]="['fas', 'download']" class="me-2"></fa-icon>Todo
          </button>
        </div>
      </div>
      <div class="dropdown" ngbDropdown>
        <button class="grid-export-btn" ngbDropdownToggle [disabled]="loadingCSV">
          <i class="fa-solid fa-file-excel"></i> Excel <i class="fa-solid fa-chevron-down ms-1" style="font-size:0.6rem"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
          <button class="dropdown-item"
            (click)="settings.returnsCSV ? downloadReturnsExcel('view') : settings.paymentsCSV ? downloadPaymentsExcel('view') : settings.contractsCSV ? downloadContractsExcel('view') : downloadFeesExcel('view')"
            [disabled]="loadingCSV">
            <fa-icon [icon]="['fas', 'eye']" class="me-2"></fa-icon>Vista
          </button>
          <button class="dropdown-item"
            (click)="settings.returnsCSV ? downloadReturnsExcel('all') : settings.paymentsCSV ? downloadPaymentsExcel('all') : settings.contractsCSV ? downloadContractsExcel('all') : downloadFeesExcel('all')"
            [disabled]="loadingCSV">
            <fa-icon [icon]="['fas', 'download']" class="me-2"></fa-icon>Todo
          </button>
        </div>
      </div>
    </ng-container>

    <!-- Separador visual si hay exports + add -->
    <span *ngIf="buttonForCreation && (settings.csv || settings.returnsCSV || settings.paymentsCSV || settings.contractsCSV || settings.feesCSV || settings.icl)"
      class="grid-header-sep"></span>

    <button *ngIf="buttonForCreation" class="grid-btn-add" (click)="addButton()">
      <fa-icon [icon]="iconPlus" style="margin-right: 5px;"></fa-icon>
      {{settings.buttontitle | translate}}
    </button>
  </div>
</div>
<div class="grid-page-header" *ngIf="title">
  <div class="grid-page-header-left">
    <h2 class="grid-page-title">{{ title }}</h2>
  </div>
  <div class="grid-page-header-right">
    <button *ngIf="buttonForCreation" class="grid-btn-add" (click)="addButton()">
      <fa-icon [icon]="iconPlus" style="margin-right: 5px;"></fa-icon>
      {{settings.buttontitle | translate}}
    </button>
  </div>
</div>

<div [ngClass]="{'ds-body': settings.titleAndSubtitle}">
  <div [ngStyle]="{'width': tableWidth}" class="table-grid table-responsive-sm">
    <loading-spinner [evaluation]="isLoaded">
      <div class="table-search-and-add">
        <app-modal-container style="display: none;" [size]="size" [modalContainer]="formTemplate"
          [cancelButton]="cancelFormButton"></app-modal-container>
        <div class="grid-toolbar">
          <!-- Barra de búsqueda + botón filtros -->
          <div class="grid-search-row">
            <div class="search" *ngIf="search">
              <select [(ngModel)]="personType" class="search-select" aria-label="Default select example">
                <option [ngValue]="item.type" *ngFor="let item of settings.search">{{item.title | translate}}</option>
              </select>
              <app-search style="width: 100%;" [parentService]="contractService" [personType]="personType"
                [gridMode]="true" (clearSearchEvent)="clearSearch()" (setResultsEvent)="setResults($event)">
              </app-search>
            </div>
            <div class="grid-filter-action">
              <div class="flex-row align-items-center gap-1">
                <div class="flex-col flex-grow-1">
                  <button
                    type="button"
                    class="grid-filter-btn w-100"
                    (click)="turnOnFilters()"
                    [class.grid-filter-btn--active]="toggleFilters || (appliedFilters && activeFilterChips.length)"
                    *ngIf="settings.filter"
                  >
                    <i class="fa-solid fa-sliders me-1"></i>{{ buttonText }} filtros
                  </button>
                </div>
                <div class="flex-col" style="width: 10px;" *ngIf="activeFilterChips.length && !toggleFilters"
                  [ngbTooltip]="'Hay filtros aplicados a esta tabla'">
                  <fa-icon class="filtered text-primary" [icon]="iconFilter" size="lg"></fa-icon>
                </div>
              </div>
            </div>
          </div>

          <!-- Panel de filtros inline (reemplaza la card flotante) -->
          <div *ngIf="toggleFilters && settings.filter" class="grid-filter-panel">
            <app-filter-v2
              (removeFilters)="appliedFilters = false"
              [allowedFilterTypes]="settings.filter"
              [orderByTypes]="settings.orderBy"
              [isLoading]="!isLoaded"
            ></app-filter-v2>
          </div>

          <!-- Chips de filtros activos (cuando el panel está cerrado) -->
          <div class="grid-active-filters" *ngIf="settings.filter && activeFilterChips.length && !toggleFilters">
            <span class="grid-active-filters-label">Filtros aplicados:</span>
            <span *ngFor="let chip of activeFilterChips" class="grid-filter-chip">
              <span class="fw-semibold">{{ chip.label }}:</span>
              {{ chip.displayValue }}
              <button type="button" class="grid-filter-chip-remove" (click)="removeFilterChip(chip)"
                [title]="'Quitar filtro'">
                <fa-icon [icon]="iconTimesChip" size="sm"></fa-icon>
              </button>
            </span>
          </div>
        </div>
      </div>

      <!-- Filter -->
      <ng-container *ngIf="renderData.length > 0 || paginatedArguments.pageNumber > 1 else Norows">
        <div class="table-template table-responsive-sm ">
          <!-- Table -->
          <table class="table table-md shadow-sm border rounded">
            <!-- Headers -->
            <thead>
              <tr class="grid-headers">
                <th scope="col" *ngIf="settings.withChecks || settings.withManyChecks">
                  <div class="flex-row ">
                    #
                  </div>
                </th>
                <th scope="col" *ngFor="let header of headers; let i = index" [ngStyle]="{width: header.width}">
                  <div class="flex-row " *ngIf="header">
                    {{ header.title | translate}}
                  </div>
                </th>
                <th scope="col" style="text-align: end; padding-right: 16px;" *ngIf="settings.actions.length > 0">
                  <!-- Acciones -->
                </th>
              </tr>
            </thead>
            <ng-template *ngIf="renderData.length == 0 else Render">
              <tbody>
                <div>{{'gridComponent.tableEmpty' | translate}}</div>
              </tbody>
            </ng-template>
          </table>
        </div>
        <!-- Paginator  -->
        <div *ngIf="totalPages > 0" class="paginator-component"
          style="justify-content:space-between; width: 100%; align-items: baseline;">
          <div>
            <span>{{footerMsg(settings.titleAndSubtitle?.title | translate)}}</span>
          </div>
          <div>
            <ngb-pagination (pageChange)="pageChanged($event)" [(page)]="paginatedArguments.pageNumber"
              [pageSize]="itemsPerPage" [collectionSize]="totalItems" [boundaryLinks]="true" [maxSize]="5">
              <ng-template ngbPaginationPrevious>Ant</ng-template>
              <ng-template ngbPaginationNext>Sig</ng-template>
            </ngb-pagination>
          </div>
          <div>
            <div class="row" style="align-items: baseline;">
              <div class="col">
                <label style="white-space: nowrap;">Filas por página:</label>
              </div>
              <div class="col">
                <select class="form-select" #pageSize (change)="changePageSize($event)">
                  <option value="10">10</option>
                  <option value="15">15</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <!-- /Paginator  -->
      </ng-container>
    </loading-spinner>
  </div>

  <!-- Rows -->
  <ng-template #Render>
    <tbody class="shadow-sm">
      <tr class="grid-rows-style" *ngFor="let row of renderData; let ind = index">
        <td *ngIf="settings.withChecks">
          <div class="checkbox-container">
            <label class="checkbox-label">
              <input type="checkbox" (change)="returnSelectElement(row, checkbox, ind)" #checkbox
                [checked]="ind == currentSelectedElement?.index && paginatedArguments.pageNumber == currentSelectedElement?.page">
              <span class="checkbox-custom rectangular"></span>
            </label>
          </div>
        </td>
        <td *ngIf="settings.withManyChecks">
          <div class="checkbox-container">
            <label class="checkbox-label">
              <input type="checkbox" (change)="returnSelectedElements(row, checkbox, ind)" #checkbox
                [checked]="isSelected(ind)">
              <span class="checkbox-custom rectangular"></span>
            </label>
          </div>
        </td>
        <td *ngFor="let item of settings.columns; let j = index">
          <div class="flex-row">
            <fa-icon *ngIf="item.key == 'icon'" [icon]="iconService.getIcon(row[j])">
            </fa-icon>
            <span *ngIf="item.key == 'index'">
              {{paginatedArguments.pageSize * (paginatedArguments.pageNumber - 1) + ind + 1}}
            </span>
            <span *ngIf="item.key != 'icon' && item.key != 'index' && !item.type">
              <span *ngIf="checkArray(row[j])">
                <span *ngFor="let rowItem of row[j]; let rowIndex = index">
                  <span *ngIf="item.urlFunction" (click)="item.urlFunction(tableData[ind][item.key][rowIndex])"
                    [ngbTooltip]="'Ver más'" placement="bottom" class="hoverblue">
                    {{rowItem}}
                  </span>
                  <span *ngIf="!item.urlFunction">
                    {{rowItem}}
                  </span>
                </span>
              </span>
              <span *ngIf="!checkArray(row[j])">
                <!-- Dropdown para propiedad -->
                <div *ngIf="item.urlFunction && item.key === 'property'" class="dropdown" style="position: relative; display: inline-block;">
                  <span (click)="togglePropertyDropdown(tableData[ind])" 
                    [ngbTooltip]="'Ver más'" placement="bottom" class="hoverblue" 
                    style="cursor: pointer;">
                    {{row[j]}}
                  </span>
                  <div *ngIf="showPropertyDropdown && currentPropertyData === tableData[ind]" 
                    class="dropdown-menu show" 
                    style="position: absolute; top: 100%; left: 0; z-index: 1000; display: block; min-width: 160px; padding: 5px 0; margin: 2px 0 0; background-color: #fff; border: 1px solid #ccc; border-radius: 4px; box-shadow: 0 6px 12px rgba(0,0,0,.175);">
                    <button class="dropdown-item" (click)="viewContractFromProperty()" 
                      style="display: block; width: 100%; padding: 3px 20px; clear: both; font-weight: normal; line-height: 1.42857143; color: #333; white-space: nowrap; background: none; border: none; text-align: left;">
                      <fa-icon [icon]="['fas', 'file-contract']" class="me-2"></fa-icon>
                      {{ 'property.dropdown.viewContract' | translate }}
                    </button>
                    <button class="dropdown-item" (click)="viewPropertyFromProperty()" 
                      style="display: block; width: 100%; padding: 3px 20px; clear: both; font-weight: normal; line-height: 1.42857143; color: #333; white-space: nowrap; background: none; border: none; text-align: left;">
                      <fa-icon [icon]="['fas', 'home']" class="me-2"></fa-icon>
                      {{ 'property.dropdown.viewProperty' | translate }}
                    </button>
                  </div>
                </div>
                <!-- Comportamiento normal para otras columnas -->
                <span *ngIf="item.urlFunction && item.key !== 'property'" (click)="item.urlFunction(tableData[ind][item.key])"
                  [ngbTooltip]="'Ver más'" placement="bottom" class="hoverblue">
                  {{row[j]}}
                </span>
                <span *ngIf="!item.urlFunction">
                  {{row[j]}}
                </span>
              </span>
            </span>
            <span *ngIf="item.type == 'amount'">
              <span>
                {{row[j] | currency:
                (tableData[ind][item.currency] === 2 ? 'USD' : 'ARS') : (tableData[ind][item.currency] === 1 ?
                'symbol-narrow' :
                'symbol') : '1.0-0' }}
              </span>
            </span>
          </div>
        </td>
        <td NOWRAP *ngIf="settings.actions.length > 0" style="text-align: end;">
          <button type="button" class="button" placement="bottom"
            [style.background-color]="action.color || 'var(--light-gray-100)'"
            [style.color]="action.color ? '#fff' : 'var(--light-gray-600)'"
            style="margin-right: 15px;" [ngbTooltip]="action.tooltip" (click)="action.function(rawData[ind])"
            *ngFor="let action of settings.actions">
            <div>
              <fa-icon *ngIf="action.icon" [icon]="action.icon"></fa-icon>
              <div *ngIf="action.text">{{action.text}}</div>
            </div>
          </button>
        </td>
      </tr>
    </tbody>
  </ng-template>

  <!-- No Rows -->
  <ng-template #Norows>
    <!-- <div>{{'gridComponent.tableEmpty' | translate}}</div> -->
    <div class="empty border shadow-sm">
      <fa-icon style="margin-bottom: 5px;" [icon]="iconQuestion" size="4x"></fa-icon>
      <span *ngIf="customEmptyMessage">{{ customEmptyMessage }}</span>
      <span style="margin-bottom: 5px;" *ngIf="!customEmptyMessage">{{'gridComponent.tableEmpty' | translate}}</span>
    </div>
  </ng-template>
</div>